import { useMemo } from 'react';
import { LogoSection } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/composer.pb';
import { useComposerSection } from '../../content-composer/hooks/use-composer-section';
import { JustifiedLayout } from '../atoms/justified-layout';
import { SectionFrame } from '../atoms/section-frame';
import { ImageWithDimensions } from '../types';

export const LogoOutput = () => {
  const { props, dom } = useComposerSection<LogoSection>();

  // TODO: Handle the unlikely edge case when images are still downloading into the editor and naturalHeight/naturalWidth is 0
  const logoWithDimensions = useMemo(() => {
    const element = dom?.querySelectorAll('img[data-type="src-image"]')[0];

    if (!element) return undefined;

    const sourceImage = element as HTMLImageElement;
    const url = sourceImage.src;
    const name = sourceImage.alt;
    const width = sourceImage.naturalWidth;
    const height = sourceImage.naturalHeight;

    if (url && width && height) {
      const logoWithDimensions: ImageWithDimensions = {
        url,
        name,
        width,
        height,
      };
      return logoWithDimensions;
    }
    return undefined;
  }, [dom]);

  return logoWithDimensions ? (
    <SectionFrame {...props.frame}>
      <JustifiedLayout
        alignment={props.frame?.alignment}
        corners={props.corners}
        height={props.height}
        images={[logoWithDimensions]}
      />
    </SectionFrame>
  ) : null;
};
